import Api from "../../../endpoint"

export const createLoadSlice = (set, get) => {
  return {
    isLoading: false,
    setIsLoading: async ({ status }) => {
      set({ isLoading: status })
    }
  }
}